import { HotjarTrackingFunction } from "Scripts/hotjar";

export class HotjarTrackingService {
    private static isDev = import.meta.env.MODE === "development";

    private static log(...args: any[]) {
        if (this.isDev) {
            console.log("[HotjarTrackingService]", ...args);
        }
    }

    /**
     * Track a page-like state change
     * @param suffix Optional string to append (e.g., modal or section)
     */
    static trackStateChange(suffix?: string) {
        const path = window.location.pathname + window.location.search;
        this.trackHotjar("stateChange", suffix ? `${path}#${suffix}` : path);
    }

    /**
     * Track a custom event (e.g., modal opened, button clicked)
     * @param eventName Event name
     */
    static trackEvent(eventName: string) {
        this.trackHotjar("event", eventName);
    }

    static trackHotjar: HotjarTrackingFunction = (
        command: "stateChange" | "event",
        value: string,
    ): void => {
        if (typeof window !== "undefined" && typeof window.hj === "function") {
            window.hj(command as any, value);
        } else {
            this.log("Hotjar not loaded", command, value);
        }
    };
}
